export default __webpack_public_path__ + "static/media/Banner_Habitacional_Mobile.06d573ea.png";